import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { WPQTPageHeader } from "../../components/common/Header/Header";
import { UserTasksFilter } from "../../components/Filter/UserTasksFilter/UserTasksFilter";
import { UserTasksContextProvider } from "../../providers/UserTasksContextProvider";
import { Page } from "../Page/Page";
import { UserTasks } from "./UserTasks";
function UserTasksPage({ userId }) {
    return (_jsx(UserTasksContextProvider, { userId: userId, children: _jsxs(Page, { children: [_jsx(WPQTPageHeader, { description: __("Tasks assigned to user", "quicktasker"), children: __("User tasks", "quicktasker") }), _jsx(UserTasksFilter, {}), _jsx(UserTasks, { userId: userId })] }) }));
}
export { UserTasksPage };
